export const Arrow = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    fill='none'
    version='1.1'
    width='16'
    height='16'
    viewBox='0 0 16 16'
  >
    <defs>
      <clipPath id='master_svg0_456_27196/281_0291'>
        <rect x='16' y='0' width='16' height='16' rx='0' />
      </clipPath>
    </defs>
    <g transform='matrix(-1,0,0,1,32,0)' clipPath='url(#master_svg0_456_27196/281_0291)'>
      <g>
        <path
          d='M26.798355,4.470226Q26.891885000000002,4.376692,26.942505,4.254485Q26.993125,4.132277,26.993125,4Q26.993125,3.9345032,26.980345,3.870265Q26.967565,3.806027,26.942505,3.745516Q26.917445,3.685004,26.881055,3.630546Q26.844665,3.5760870000000002,26.798355,3.529774Q26.752035,3.483461,26.697575,3.447073Q26.643125,3.410685,26.582605,3.38562Q26.522095,3.360556,26.457855000000002,3.347778Q26.393625,3.335,26.328125,3.335Q26.195845,3.335,26.073645,3.38562Q25.951435,3.4362399999999997,25.857895,3.529774L25.856725,3.528595L21.856721,7.5286Q21.762952,7.6223600000000005,21.712205,7.74488Q21.661458,7.86739,21.661458,8Q21.661458,8.13261,21.712205,8.25512Q21.762952,8.37764,21.856721,8.4714L25.856725,12.4714L25.857895,12.47023Q25.951435,12.56376,26.073645,12.61438Q26.195845,12.665,26.328125,12.665Q26.393625,12.665,26.457855000000002,12.65222Q26.522095,12.63944,26.582605,12.61438Q26.643125,12.58931,26.697575,12.55293Q26.752035,12.51654,26.798355,12.47023Q26.844665,12.42391,26.881055,12.36945Q26.917445,12.31499,26.942505,12.25448Q26.967565,12.19397,26.980345,12.12973Q26.993125,12.0655,26.993125,12Q26.993125,11.86772,26.942505,11.745519999999999Q26.891885000000002,11.62331,26.798355,11.52977L26.799535,11.5286L23.270934,8L26.799535,4.471405L26.798355,4.470226Z'
          fillRule='evenodd'
          fill='#333333'
          fillOpacity='1'
        />
      </g>
    </g>
  </svg>
)
